exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".company--12vkQ {\n  border: 1px solid #C0C0C0;\n  border-radius: 4px;\n  background: #FFFFFF;\n  padding: 10px 20px;\n  margin-bottom: 20px;\n}\n\n.header--2ZuQI {\n  margin-left: 15px;\n}\n", ""]);

// exports
exports.locals = {
	"company": "company--12vkQ",
	"header": "header--2ZuQI"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":false,"sourceMap":false,"localIdentName":"[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false,"plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js?{"data":"$env: production;","sourceMap":false,"outputStyle":"expanded","precision":10,"includePaths":["/app/node_modules","/app/src"]}!./src/containers/Private/pages/workflow-client/Acquiring/Acquiring.m.scss
// module id = 1440
// module chunks = 0